// extracted by mini-css-extract-plugin
module.exports = {"container":"AuthorBio_container__sk0W_"};